import queryString from 'query-string'
import isEmpty from 'lodash/isEmpty'

import { fetchingAPI, apiService } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

import { setLoading, setData } from './featureFeedback.redux'

export const fetchFeatureFeedback =
  (params = {}) =>
  async (dispatch) => {
    dispatch(setLoading({ feedback: true }))

    try {
      const queryParams = isEmpty(params) ? '' : `?${queryString.stringify(params)}`
      const response = await fetchingAPI(
        `${apiService.reporting}/api/feature_feedback${queryParams}`
      )
      dispatch(setData({ feedback: response }))
    } catch (error) {
      console.error('Error fetching feature feedback:', error)
    } finally {
      dispatch(setLoading({ feedback: false }))
    }
  }

export const fetchFeatureFeedbackAggregate =
  (params = {}) =>
  async (dispatch) => {
    dispatch(setLoading({ aggregate: true }))

    try {
      const queryParams = isEmpty(params) ? '' : `?${queryString.stringify(params)}`
      const response = await fetchingAPI(
        `${apiService.reporting}/api/feature_feedback/aggregate${queryParams}`
      )
      dispatch(setData({ aggregate: response }))
    } catch (error) {
      console.error('Error fetching feature feedback aggregate:', error)
    } finally {
      dispatch(setLoading({ aggregate: false }))
    }
  }

export const sendFeatureFeedback = (feedbackData) => async (dispatch, getState) => {
  const { user_id: userId } = getState().currentUser

  try {
    await fetchingAPI(
      `${apiService.reporting}/api/feature_feedback`,
      'POST',
      dispatch,
      JSON.stringify({ ...feedbackData, user_id: userId }),
      undefined,
      { isSilent: true }
    )

    toast.success('Thanks for your feedback!')

    return true
  } catch (error) {
    console.error('Error sending feature feedback:', error)
    toast.error('Failed to submit feedback. Please try again.', { cause: error })

    return false
  }
}

// A filter change can outrun a slow response, so each fetch is numbered and only the
// newest may write; otherwise the range just left would land under the one just picked.
let latestAiAnswersRequest = 0
let latestAiAnswersMetricsRequest = 0

export const fetchAiAnswers =
  (params = {}) =>
  async (dispatch) => {
    const requestId = latestAiAnswersRequest + 1
    latestAiAnswersRequest = requestId

    dispatch(setLoading({ aiAnswers: true }))

    try {
      const queryParams = isEmpty(params) ? '' : `?${queryString.stringify(params)}`
      const response = await fetchingAPI(
        `${apiService.agentGpt}/questions/question_answer_feedback${queryParams}`
      )

      if (requestId === latestAiAnswersRequest) {
        dispatch(setData({ aiAnswers: response }))
      }
    } catch (error) {
      console.error('Error fetching AI answers:', error)
    } finally {
      if (requestId === latestAiAnswersRequest) {
        dispatch(setLoading({ aiAnswers: false }))
      }
    }
  }

export const fetchAiAnswersMetrics =
  (params = {}) =>
  async (dispatch) => {
    const requestId = latestAiAnswersMetricsRequest + 1
    latestAiAnswersMetricsRequest = requestId

    dispatch(setLoading({ aiAnswersMetrics: true }))

    try {
      const queryParams = isEmpty(params) ? '' : `?${queryString.stringify(params)}`
      const response = await fetchingAPI(
        `${apiService.agentGpt}/questions/question_answer_metrics${queryParams}`
      )

      if (requestId === latestAiAnswersMetricsRequest) {
        dispatch(setData({ aiAnswersMetrics: response }))
      }
    } catch (error) {
      console.error('Error fetching AI answers metrics:', error)

      if (requestId === latestAiAnswersMetricsRequest) {
        // Otherwise a failed refetch would leave the previous filter's totals on the card.
        dispatch(setData({ aiAnswersMetrics: null }))
      }
    } finally {
      if (requestId === latestAiAnswersMetricsRequest) {
        dispatch(setLoading({ aiAnswersMetrics: false }))
      }
    }
  }
